import { Component, OnInit } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Domain } from '@app/shared/models/domain';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import * as fromSignup from '../../../reducers';

@Component({
  selector: 'app-modal-domain-creation-process',
  templateUrl: './modal-domain-creation-process.component.html',
  styleUrls: ['./modal-domain-creation-process.component.scss']
})
export class ModalDomainCreationProcessComponent implements OnInit {

  teamCreated$: Observable<boolean>;
  domainCreationFailed$: Observable<boolean>;

  constructor(private store$: Store<fromRoot.State & fromSignup.State>, public ref: DialogRef) {
    this.teamCreated$ = this.store$.select(fromSignup.getTeamCreated);
    this.domainCreationFailed$ = this.store$.select(fromSignup.getDomainCreationFailed);

    this.teamCreated$.pipe(first(created => !!created)).subscribe(() => setTimeout(() => this.closeModal()));
    this.domainCreationFailed$.pipe(first(failed => !!failed)).subscribe(() => setTimeout(() => { this.closeModal() }, 2000));

  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.ref.close();
  }
}
